import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class FishermansHutBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.FISHERMANS_HUT;
}

export default FishermansHutBuildingTileEntity;
